import { createContext } from 'react'
import { Merch as TypeMerch, MerchAction } from 'out-game/types'

export const IsOpen = createContext(false)
export const SetOpen = createContext<Function>(console.warn)

export const Merch = createContext<TypeMerch | null>(null)
export const SetMerch = createContext<Function>(console.warn)

export const Action = createContext<MerchAction | null>(null)
export const SetAction = createContext<Function>(console.warn)

export const ActionDone = createContext(false)
export const SetActionDone = createContext<Function>(console.warn)
